import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";

import { useTheme } from "styled-components";

import { Button } from "simplydo/react/ui";

import { useAppSelector } from "store";
import util from "utils/utils";

import RowComponent from "components/lib/RowComponent";

import type { HomeGroup } from "./types";

const sortDiscoverable = (
  groups: HomeGroup[],
  user: Parameters<typeof util.isInGroup>[0],
) =>
  groups.sort((a, b) => {
    const isInA = util.isInGroup(user, a);
    const isInB = util.isInGroup(user, b);
    if (isInB && !isInA) return 1;
    if (isInA && !isInB) return -1;
    return 0;
  });

type HomeGroupsProps = { groups: HomeGroup[] };
const HomeGroups = ({ groups }: HomeGroupsProps) => {
  const user = useAppSelector((state) => state.user);
  const theme = useTheme();
  const { t } = useTranslation();
  if (!groups.length) return null;
  return (
    <RowComponent>
      <RowComponent.Fill>
        <RowComponent.Title style={{ textTransform: "capitalize" }}>
          {t("generic.groups")}
        </RowComponent.Title>
        <Button as={Link} to="/groups" primary size="mini">
          {t("users.home.groups.view.all")}
        </Button>
      </RowComponent.Fill>
      {sortDiscoverable(groups, user)
        .slice(0, 4)
        .map((group, index) => (
          <RowComponent.Cell
            index={index}
            key={group._id}
            as={Link}
            to={`/groups/${group._id}`}
          >
            <div
              style={{
                width: 40,
                height: 40,
                borderRadius: 3,
                flex: "0 0 40px",
                backgroundSize: "cover",
                backgroundPosition: "center center",
                backgroundImage: `url(${
                  group?.coverImage ? util.groupCoverImage(group)
                  : group?.bannerImage ? util.groupBannerImage(group)
                  : "https://cdn.simplydo.co.uk/images/groupCoverImage.png"
                })`,
                backgroundColor:
                  !group?.coverImage && !group?.bannerImage ?
                    theme.accent
                  : null,
              }}
            />
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                marginLeft: 5,
                marginRight: 5,
                position: "relative",
                top: -1,
              }}
            >
              <RowComponent.Title wrapping style={{ color: "#5d5d5d" }} block>
                {group.name}
              </RowComponent.Title>
              <RowComponent.StatusArea>
                {util.isInGroup(user, group) ?
                  <>
                    <RowComponent.StatusLabel color="green" />{" "}
                    {t("users.home.groups.member")}
                  </>
                : <>
                    <RowComponent.StatusLabel color="blue" />
                    {t("users.home.groups.available")}
                  </>
                }
              </RowComponent.StatusArea>
            </div>
          </RowComponent.Cell>
        ))}
    </RowComponent>
  );
};

export default HomeGroups;
